const imageScalePattern = /\/@@images\/image\/[^/?#]+(?=$|[?#])/;

export const normalizeTableValue = (value) => {
  if (Array.isArray(value)) {
    return value.map(normalizeTableValue);
  }

  if (!value || typeof value !== 'object') return value;

  if (value.type === 'img' && typeof value.url === 'string') {
    return {
      ...value,
      url: value.url.replace(imageScalePattern, '/@@images/image'),
    };
  }

  if (Array.isArray(value.children)) {
    return { ...value, children: normalizeTableValue(value.children) };
  }

  return value;
};
